import { useState } from "react";
import { hotMangas } from "@/mocks/manga";
import MangaCard from "./MangaCard";

const filters = ["全部", "都市怪谈", "病态美学", "禁忌异闻", "硬核猎奇", "暗黑心理", "末日废土", "邪典"];

export default function HotSection() {
  const [active, setActive] = useState("全部");
  const list =
    active === "全部" ? hotMangas : hotMangas.filter((m) => m.category === active);

  return (
    <section id="hot" className="py-14 md:py-20 bg-background-100/50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-6 flex-wrap gap-4">
          <div>
            <p className="text-xs tracking-widest text-primary-400 mb-2">热门推荐 · 正在追</p>
            <h2 className="font-heading text-2xl md:text-4xl font-black text-foreground-950">
              猎奇热门精选
            </h2>
          </div>
        </div>

        <div className="flex flex-wrap gap-2 mb-8">
          {filters.map((f) => (
            <button
              key={f}
              type="button"
              onClick={() => setActive(f)}
              className={`px-4 py-1.5 rounded-full text-sm transition-colors whitespace-nowrap ${
                active === f
                  ? "bg-primary-600 text-foreground-950 font-medium"
                  : "bg-background-200/60 text-foreground-400 hover:text-foreground-200 hover:bg-background-300/50"
              }`}
            >
              {f}
            </button>
          ))}
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {list.map((manga) => (
            <MangaCard key={manga.id} manga={manga} />
          ))}
        </div>
      </div>
    </section>
  );
}